import "core-js/modules/es.array.push.js";
import Bus from '@/assets/js/bus.js';
import axios from 'axios';
import { mapState } from 'vuex';
const CancelToken = axios.CancelToken;
export default {
  props: {
    outputRtilCode: [String, Number],
    devicePeerId: [String, Number],
    slotNum: [String, Number],
    receiverNicknames: String,
    partyCode: [String, Number],
    partyInfo: Object,
    nickNameInfo: Object,
    mainWindowList: Array,
    pageNum: [String, Number],
    globalControlId: [String],
    showTitle: {
      type: Boolean,
      default: true
    },
    rtilCodeList: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data() {
    return {
      outputSourceType: 'VFB',
      showTag: false,
      nickName: '',
      enableTag: false,
      sourceTypeTag: '',
      input: '',
      getReceiverParams: {
        pageNum: 1,
        pageSize: 10,
        living: true,
        offline: false,
        online: true,
        condition: ''
      },
      Url: '',
      // showSelect: false,
      coHostReceiverNickname: '',
      receiverNickname: '',
      Username: '',
      UserVfbname: '',
      encoderInfo: {
        visible: false,
        data: [],
        maxNumber: 1
      },
      selectOutputType: '',
      localState: {
        selectOutput: '',
        mainwindowId: '',
        isTag: 0,
        mainwindowType: ''
      },
      selectOutput: '',
      mainwindowId: '',
      mainwindowType: '',
      outputList: [],
      pipList: [],
      sourceVfbType: {
        show: false
      },
      liveLoading: false,
      sendReceiverInfo: {},
      mainwindowPBP: [],
      pbpList: [{
        position: 1,
        text: 'selectLeftSource',
        rtilCode: '',
        outputList: []
      }, {
        position: 2,
        text: 'selectRightSource',
        rtilCode: '',
        outputList: []
      }],
      changeSourceParams: {
        VFB: 'Receiver',
        PP: 'Producer',
        pip: 'Participant',
        PBP: 'Pbp',
        shareScreen: 'ShareScreen',
        Tag: 'Tag'
      },
      requestUrl: {
        send: {
          party: '/partyline-backend/commonParty/startPushStream',
          kiosk: '/partyline-backend/kiosk/v2/startPushStream',
          group: '/partyline-backend/group/v2/startPushStream',
          coordinator: '/partyline-backend/conference/startPushStream',
          globalControl: '/partyline-backend/globalControl/startPushStream',
          interview: '/partyline-backend/interview/startMainWindow'
        },
        stop: {
          party: '/partyline-backend/commonParty/stopPushStream',
          kiosk: '/partyline-backend/kiosk/v2/stopPushStream',
          group: '/partyline-backend/group/v2/stopPushStream',
          coordinator: '/partyline-backend/conference/stopPushStream',
          globalControl: '/partyline-backend/globalControl/stopPushStream',
          interview: '/partyline-backend/interview/stopMainWindow'
        }
      },
      showPreviewBox: false,
      globalMainInfo: {},
      listScroll: {
        distance: 15,
        directive: '.selectBox .el-scrollbar__wrap',
        onScroll: this.loadNextPage
      },
      receiverListInfo: {},
      cancel: {}
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      ChannelMode: state => state.channelMode
    }),
    sendBtnColor() {
      let color = 'gray';
      if (this.selectOutputType == 'PBP') {
        const mainwindowPBPIds = this.mainwindowPBP.map(v => v.rtilCode);
        this.pbpList.forEach(val => {
          if (val.rtilCode) {
            color = 'green';
          }
          if (mainwindowPBPIds !== null && mainwindowPBPIds !== void 0 && mainwindowPBPIds.includes(val.rtilCode)) {
            color = 'red';
          }
        });
      } else {
        if (!this.selectOutput && this.selectOutputType != 'Tag') {
          color = 'gray';
        }
        if (this.selectOutput || this.selectOutputType == 'Tag' && this.enableTag == false) {
          color = 'green';
        }
        // 为了 Gallery view 在单独添加一种判断
        if (this.selectOutput && this.selectOutput == this.mainwindowId || this.selectOutput && this.selectOutput == this.nickName || this.selectOutput && this.selectOutput == this.coHostReceiverNickname && this.selectOutputType != 'Tag' || this.selectOutput && this.$route.name === 'group' && this.selectOutputType === 'shareScreen' || this.State.isTag == 1 && this.selectOutputType == 'Tag') {
          color = 'red';
        }
      }
      return color;
    },
    showSelectBox() {
      if (this.$route.name === 'group' && this.selectOutput && this.selectOutputType === 'shareScreen') {
        return true;
      }
      return false;
    },
    returnClass() {
      return this.$route.name === 'party' && this.selectOutputType === 'PP' ? 'partyMode' : '';
    },
    returnPlaceholder() {
      let placeholder = '';
      if (this.selectOutputType === 'Tag') {
        placeholder = this.$t('kioskHost.tagInput');
      } else {
        placeholder = 'Select a Receiver';
      }
      return placeholder;
    },
    returnNoData() {
      let noData = '';
      if (this.selectOutputType === 'PP') {
        noData = this.$t('common.noProgram');
      } else {
        noData = this.$t('common.noMainWinDowData');
      }
      return noData;
    }
  },
  watch: {
    devicePeerId: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.selectOutput = newVal;
        this.mainwindowId = this.selectOutput;
      }
    },
    mainwindowType: function (val) {
      let btn = false;
      this.mainWindowList.forEach(v => {
        v.options.forEach((value, index) => {
          if (val == 'PBP') {
            if (value.value == 'shareScreen') {
              v.options.splice(index, 1);
            }
          } else {
            if (value.value == 'shareScreen') {
              btn = true;
            }
          }
        });
        // Conference 页面不需要分享
        if (!btn && val != 'PBP' && this.$route.name != 'newCoordinator' && this.$route.name != 'coordinator' && this.$route.name != 'globalControl') {
          v.options.push({
            value: 'shareScreen',
            label: 'Shared Screen'
          });
        }
      });
    }
  },
  created() {
    this.selectOutputType = 'VFB';
    this.getOutputList('getReceiverList');
  },
  methods: {
    returnNameByDeviceType(voip, name, obj) {
      let nickName;
      if (voip) {
        nickName = name + '_voip';
      } else {
        nickName = name + '_' + obj.source + `_${obj.channelCount}`;
      }
      return nickName;
    },
    updateTagStage() {
      this.enableTag = false;
      this.State.isTag = 0;
    },
    // 控制显示mainWindow的Tag的hover提示
    showTagTooltip(type) {
      if (this.selectOutputType == 'Tag') {
        if (type == 'enter') {
          this.showTag = true;
        } else {
          this.showTag = false;
        }
      }
    },
    sendApplyAll() {
      if (this.selectOutputType != 'Tag') {
        this.$emit('callback', {
          type: 'applyAll'
        });
      } else {
        this.$emit('callback', {
          type: 'applyAll',
          sourceType: 'Tag'
        });
      }
    },
    getOnlineMember() {
      this.axios.get(`/partyline-backend/conference/onlineMembers/${this.partyCode}`).then(res => {
        if (res.data.errorCode === '0x0') {
          const role2List = res.data.result[2] || [];
          const role4List = res.data.result[4] || [];
          let reportList = role2List.concat(role4List);
          // 在speaker列表里面移除anywhere
          reportList = reportList.filter(v => {
            return !v.excludeSpeakerCandidate && v.nickName;
          });
          // 如果当前 host 不是 questioner，speaker，questionerSpeaker 需要加入到列表里面
          if (!this.State.showConferenceLocal) {
            reportList.unshift({
              nickName: this.partyInfo.behavior.nickName,
              rtilCode: this.partyInfo.rtilCode,
              organization: this.partyInfo.behavior.organization
            });
          }
          reportList.forEach(v => {
            v.visible = false;
            v.mainwindowId = v.rtilCode;
          });
          this.outputList = reportList;
        }
      });
    },
    getOutputList(type, visiable, val) {
      // if (!val) return
      if (this.selectOutputType === 'VFB' || this.selectOutputType === 'PP' || this.selectOutputType === 'Tag') {
        // 单独为 Common party mianwindow 添加特殊逻辑
        if (this.selectOutputType === 'PP' && this.$route.name === 'party') {
          this.getAllPpList();
        } else {
          this.getReceiverList(type, '', visiable, val);
        }
      } else if (this.selectOutputType === 'Broadcaster') {
        let codeList = [];
        const pipLists = [];
        codeList = JSON.parse(JSON.stringify(this.rtilCodeList));
        codeList = codeList.filter(rtilcode => {
          return rtilcode > 0;
        });
        codeList.forEach(val => {
          const type = this.State.deviceTypeMap[val];
          if (this.nickNameInfo[val] && type != 'T' && type != 'R' && type != 'Anywhere' && type != 'App') {
            pipLists.push({
              mainwindowId: val
            });
          }
        });
        this.outputList = pipLists;
      } else if (this.selectOutputType === 'pip' && this.$route.name === 'coordinator') {
        this.getOnlineMember();
      } else {
        this.getParticipantsList();
      }
    },
    loadNextPage() {
      if (this.selectOutputType === 'VFB' && this.receiverListInfo.hasNextPage) {
        this.getReceiverList('getReceiverList', 'loadNextPage');
      }
    },
    getReceiverList(type, loadNextPage, visiable, val) {
      if (type === 'filter') this.cancel.getReceiverList();
      loadNextPage ? this.getReceiverParams.pageNum++ : this.getReceiverParams.pageNum = 1;
      if (visiable) {
        this.getReceiverParams.condition = '';
      } else {
        this.getReceiverParams.condition = val;
      }
      const _this = this;
      const params = this.getReceiverParams;
      params.queryCollaborate = true;
      this.axios.post('/partyline-backend/receiver/v3/page', params, {
        cancelToken: new CancelToken(function executor(c) {
          _this.cancel.getReceiverList = c;
        })
      }).then(res => {
        if (res && res.data.errorCode === '0x0') {
          const result = res.data.result;
          if (this.selectOutputType === 'VFB') {
            this.receiverListInfo = result.cc;
            if (loadNextPage) {
              this.outputList = this.outputList.concat(result.cc.list);
            } else {
              this.outputList = result.cc.list;
            }
          } else {
            const ppList = res.data.result.pps;
            const array = [];
            ppList === null || ppList === void 0 ? void 0 : ppList.forEach(item => {
              item.pageInfo.list.forEach(item1 => {
                array.push({
                  ...item.user,
                  ...item1
                });
              });
            });
            this.outputList = array;
          }
          this.outputList.forEach(val => {
            val.mainwindowId = val.peerId || val.receiverId;
          });
        }
      });
    },
    // common party 有些做功能所以需要获取所有协作的实例
    getAllPpList() {
      const params = {
        pageNum: 1,
        pageSize: 100,
        living: true,
        offline: false,
        online: true,
        queryCollaborate: true
      };
      this.axios.post('/partyline-backend/receiver/v3/page', params).then(res => {
        if (!res) return;
        if (res.data.errorCode === '0x0') {
          const ppList = res.data.result.pps;
          const array = [];
          ppList === null || ppList === void 0 ? void 0 : ppList.forEach(item => {
            item.pageInfo.list.forEach(item1 => {
              array.push({
                ...item.user,
                ...item1
              });
            });
          });
          this.outputList = array;
          this.outputList.forEach(val => {
            val.mainwindowId = val.peerId || val.receiverId;
          });
        }
      });
    },
    getParticipantsList() {
      if (this.$route.name === 'party') {
        this.Url = '/partyline-backend/commonParty/noLogin/getViewRtilCodes';
      } else {
        this.Url = '/partyline-backend/kiosk/noLogin/getViewRtilCodes';
      }
      this.axios.get(this.Url, {
        params: {
          partyCode: this.partyCode
        }
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          if (this.$route.name === 'party') {
            this.outputList = res.data.result.viewPosition.participant.concat(res.data.result.viewPosition.host);
          } else {
            this.outputList = res.data.result.viewPosition.participant;
          }
          const pipLists = [];
          this.outputList.forEach(val => {
            pipLists.push({
              mainwindowId: val
            });
          });
          this.outputList = pipLists;
          this.pipList = JSON.parse(JSON.stringify(this.outputList));
          // 处理 pbp list
          if (!this.pbpList[0].rtilCode && !this.pbpList[1].rtilCode) {
            this.pbpList.forEach(item => {
              item.outputList = pipLists;
            });
          } else if (this.pbpList[0].rtilCode && !this.pbpList[1].rtilCode) {
            this.$set(this.pbpList[0], 'outputList', pipLists);
            this.$set(this.pbpList[1], 'outputList', pipLists.filter(info => {
              return this.pbpList[0].rtilCode != info.mainwindowId;
            }));
          } else if (!this.pbpList[0].rtilCode && !this.pbpList[0].rtilCode) {
            this.$set(this.pbpList[0], 'outputList', pipLists.filter(info => {
              return this.pbpList[1].rtilCode != info.mainwindowId;
            }));
            this.$set(this.pbpList[1], 'outputList', pipLists);
          } else {
            this.$set(this.pbpList[0], 'outputList', pipLists.filter(info => {
              return this.pbpList[1].rtilCode != info.mainwindowId;
            }));
            this.$set(this.pbpList[1], 'outputList', pipLists.filter(info => {
              return this.pbpList[0].rtilCode != info.mainwindowId;
            }));
          }
        }
      });
    },
    async showVfbDialog(item, type) {
      this.$emit('callback', {
        type: 'savePreviewName',
        val: item.name
      });
      if (this.selectOutputType == 'VFB') {
        // 给receiverNickname赋值
        this.UserVfbname = item.name;
        this.sourceVfbType.currentRId = item.mainwindowId;
        this.sourceVfbType.sourceType = 'VFB';
        this.sourceVfbType.params = {
          receiverId: item.mainwindowId // 会存在再点击的时候，change事件在click之后，selectout还未改变值,所以要用item的值
        };

        this.sendReceiverInfo.outputRid = this.partyInfo.status ? this.partyInfo.status.outputId : this.globalMainInfo.outputId; // item.mainwindowId
        this.sendReceiverInfo.outputSourceType = this.partyInfo.status ? this.partyInfo.status.outputSource : this.globalMainInfo.outputSource;
        this.sourceVfbType.show = true;
        this.sourceVfbType.productionId = '';
      }
      if (this.selectOutputType == 'PP') {
        // 先判断是否存在多声道，如果存在则弹窗
        await this.axios.get(`/partyline-backend/receiver/getEncoderSourcesV2/${item.mainwindowId}`).then(res => {
          if (res.data.errorCode == '0x0') {
            const result = res.data.result;
            result.forEach(val => {
              if (val.name == 'PGM') {
                // 给receiverNickname赋值
                this.Username = item.name;
                this.sourceVfbType.currentRId = item.mainwindowId;
                this.sourceVfbType.sourceType = 'PGM';
                this.sourceVfbType.params = {
                  receiverId: item.mainwindowId // 会存在再点击的时候，change事件在click之后，selectout还未改变值,所以要用item的值
                };

                this.sendReceiverInfo.outputRid = this.partyInfo.status ? this.partyInfo.status.outputId : this.partyInfo.outputId;
                this.sendReceiverInfo.outputSourceType = this.partyInfo.status ? this.partyInfo.status.outputSource : this.partyInfo.outputSource;
                this.sourceVfbType.show = true;
                if (item.id) {
                  this.sourceVfbType.productionId = item.id;
                } else {
                  this.outputList.forEach(item => {
                    if (item.receiverId == this.selectOutput) {
                      this.sourceVfbType.productionId = item.id;
                    }
                  });
                }
              }
            });
          }
        });
      }
    },
    updateVfbData(obj) {
      if (obj.operateType == 'stop') {
        this.stopReceiverParty(obj);
      } else if (obj.operateType == 'send') {
        this.StartReceiverParty(obj);
      }
    },
    async controlOutput() {
      const _this = this;
      if (_this.sendBtnColor == 'gray') return;
      if (_this.selectOutputType === 'shareScreen') {
        _this.shareScreenByMainwindow();
        return;
      }
      if (_this.selectOutputType === 'pip' || _this.selectOutputType == 'PBP' || _this.selectOutputType == 'Tag') {
        if (_this.sendBtnColor == 'red') {
          this.stopReceiverParty();
        } else {
          if (_this.selectOutputType == 'PBP') {
            const rtilCodes = this.pbpList.map(v => v.rtilCode);
            if ([...new Set(rtilCodes)].length < rtilCodes.length) {
              _this.$message.error('Please select two different pips.');
              return;
            }
          }
          _this.StartReceiverParty();
        }
      } else {
        if (_this.sendBtnColor == 'red') {
          // 为了 Gallery view 特殊添加
          if (_this.selectOutputType === 'Broadcaster') {
            _this.$emit('callback', {
              type: 'stopBroadcaster',
              val: this.selectOutput
            });
          } else {
            _this.stopReceiverParty();
          }
        } else {
          // 为了 Gallery view 特殊添加
          if (_this.selectOutputType === 'Broadcaster') {
            _this.$emit('callback', {
              type: 'startBroadcaster',
              val: this.selectOutput,
              nickName: this.nickNameInfo[this.selectOutput]
            });
          }
          if (_this.selectOutputType == 'VFB' || _this.selectOutputType === 'PP') {
            this.showVfbDialog({
              mainwindowId: this.selectOutput
            }, 'sendBtn');
          }
        }
      }
    },
    async stopReceiverParty(obj = {}) {
      let params = {};
      if (this.globalControlId) {
        params = {
          globalControlId: this.globalControlId,
          sourceType: this.changeSourceParams[this.selectOutputType]
        };
      } else {
        params = {
          partyCode: this.partyCode,
          slotNum: this.slotNum,
          rtilCode: this.outputRtilCode
        };
      }
      if (this.liveLoading) return;
      // 为了 Global Control 添加
      if (JSON.stringify(this.globalMainInfo) != '{}') return;
      this.liveLoading = true;
      const routeName = this.$route.name;
      await this.axios.post(this.requestUrl.stop[routeName], params).then(res => {
        this.liveLoading = false;
        if (res.data.errorCode === '0x0') {
          // this.showSelect = false
          this.$message.success(this.$t('galleryHost.stopSucc'));
          // 用于关闭选择vfb type的弹窗
          obj.callback && obj.callback(obj);
          this.partyInfo.status.outputSource = '';
          this.partyInfo.status.outputId = '';
          this.partyInfo.status.output = '';
        }
      }).catch(() => {
        this.liveLoading = false;
      });
    },
    StartReceiverParty(obj = {}) {
      if ((!this.partyCode || this.sendBtnColor != 'green' && !obj.operateType) && !this.globalControlId) return;
      // 为了 kiosk globalControl 特意加的
      let params = {};
      if (this.globalControlId) {
        params = {
          globalControlId: this.globalControlId,
          mainWindowType: this.changeSourceParams[this.selectOutputType]
        };
      } else {
        params = {
          partyCode: this.partyCode,
          mainWindowType: this.changeSourceParams[this.selectOutputType],
          slotNum: this.slotNum
        };
      }
      if (this.selectOutputType == 'VFB' || this.selectOutputType == 'PP') {
        params.receiverSource = {
          receiverId: this.selectOutput,
          source: obj.source,
          trackIds: obj.trackIds,
          nickName: this.returnNameByDeviceType('', this.UserVfbname, obj)
        };
        if (!this.selectOutput) return;
      }
      if (this.selectOutputType == 'pip') {
        params.pipSource = {
          rtilCode: this.selectOutput,
          nickName: this.nickNameInfo[this.selectOutput]
        };
      }
      if (this.selectOutputType == 'PBP') {
        params.pbpInfo = {
          pbpSources: this.pbpList,
          layout: '50%'
        };
      }
      if (this.selectOutputType == 'shareScreen') {
        params.shareMsg = {
          rtilCode: this.selectOutput
        };
      }
      if (this.liveLoading) return;
      this.liveLoading = true;
      const routeName = this.$route.name;
      this.axios.post(this.requestUrl.send[routeName], params).then(res => {
        // this.showSelect = true
        this.liveLoading = false;
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('galleryHost.sendSucc'));
          // 用于关闭选择vfb type的弹窗
          obj.callback && obj.callback(obj);
          this.partyInfo.status.outputSource = params.receiverSource ? params.receiverSource.sourceType : '';
          this.partyInfo.status.outputId = this.selectOutput || obj.currentRId;
        } else if (res.data.errorCode == '82201204') {
          const result = JSON.parse(res.data.errorInfo);
          const array = [];
          result.encoders.forEach(item => {
            const obj = {};
            obj.code = item.code;
            obj.title = item.title ? item.title : new Date(item.createTime).toLocaleDateString() + ' ' + new Date(item.createTime).toLocaleTimeString();
            obj.mode = this.ChannelMode[item.mode] ? this.ChannelMode[item.mode].toLowerCase() : '';
            if (item.loginUser) {
              obj.email = item.loginUser.email;
            }
            obj.outputSource = item.vfbSource;
            obj.realPartyCode = item.realPartyCode;
            obj.rid = this.selectOutput;
            obj.loginUser = item.loginUser;
            obj.globalControlId = item.globalControlId;
            obj.hasStop = false;
            obj.loading = false;
            array.push(obj);
          });
          this.encoderInfo.maxNumber = result.maxEncoderNumber;
          this.encoderInfo.data = array;
          this.encoderInfo.visible = true;
          this.sourceVfbType.show = false;
        }
      }).catch(() => {
        this.liveLoading = false;
      });
    },
    async shareScreenByMainwindow() {
      if (this.mainwindowId && this.mainwindowType == 'shareScreen') {
        // 如果host直接分享的mainwindow，则stop需要用户自己点停止按钮取消,取消mainwindow和 stop share
        // 如果存在share的大屏，先取消
        // 如果切换了share，还需要发起setoutput
        if (this.sendBtnColor == 'green' && this.selectOutput) {
          this.StartReceiverParty();
        }
        if (this.sendBtnColor == 'red') {
          this.stopReceiverParty();
        }
        return;
      }
      this.selectOutput && this.StartReceiverParty();
    }
  },
  beforeDestory() {
    Bus.$off('setOutput');
    Bus.$off('cancelOutput');
  }
};